import { render, staticRenderFns } from "./mobile-captcha.vue?vue&type=template&id=015ca294&"
import script from "./mobile-captcha.vue?vue&type=script&lang=js&"
export * from "./mobile-captcha.vue?vue&type=script&lang=js&"
import style0 from "./mobile-captcha.vue?vue&type=style&index=0&id=015ca294&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports